import { DEFAULT_APPEARANCE, type AppearanceSettings } from './types';

export const applyAppearanceToRoot = (
  settings: AppearanceSettings,
  systemDark: boolean,
  systemReduced: boolean,
): void => {
  const root = document.documentElement;
  root.setAttribute('data-theme-preference', settings.theme);
  root.setAttribute('data-theme', settings.theme === 'system' ? (systemDark ? 'dark' : 'light') : settings.theme);
  root.setAttribute('data-accent', settings.accent);
  root.setAttribute('data-density', settings.density);
  root.setAttribute('data-motion', settings.motion === 'reduced' || systemReduced ? 'reduced' : 'full');
  root.style.setProperty('--shark-font-size', `${settings.font_size}px`);
};

export const resetRootAppearance = (): void => {
  document.documentElement.style.removeProperty('--shark-font-size');
  applyAppearanceToRoot(DEFAULT_APPEARANCE, false, false);
};
